import { render, staticRenderFns } from "./Wellcome.vue?vue&type=template&id=1da9b89c&"
import script from "./Wellcome.vue?vue&type=script&lang=js&"
export * from "./Wellcome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports